<script>
import AudioPlayerTimeline from "./AudioPlayerTimeline.vue";
import PlayButton from './PlayButton';

export default {
  name: 'AudioPlayerControls',
  components: {
    AudioPlayerTimeline,
    PlayButton
  },
  props: {
    currentTime: Number,
    trackSlug: String,
    hotspots: Array | Boolean,
    isPlaying: Boolean,
  },
  data: () => {
    return {
      isScrubbing: false,
      timeValue: 0
    };
  },
  watch: {
    currentTime: function(newVal) {
      if (!this.isScrubbing) {
        this.timeValue = parseInt(newVal);
      }
    }
  },
  methods: {
    onPlayToggle() {
      if (this.isPlaying) {
        this.$emit('pause');
      } else {
        this.$emit('play');
      }
    },
    onTimeChange() {
      this.isScrubbing = false;
      this.$emit('timeupdate', this.timeValue);
      this.$emit('scrubbing', false);
    },
    onTimeInput() {
      // this.$emit('timeupdate', this.timeValue);
      this.$emit('scrubbing', true);
      this.isScrubbing = true;
    }
  }
};
</script>

<template>
  <div class="controls">
    <audio-player-timeline 
      v-on:change="onTimeChange()" 
      v-on:input="onTimeInput()" 
      v-model.number="timeValue"
      v-bind:trackSlug="trackSlug"
      v-bind:hotspots="hotspots">
    </audio-player-timeline>
  </div>
</template>

<style scoped lang="scss">
@import "../assets/styles/variables";

.play-button {
  position: absolute;
  top: -2rem;
  left: 1rem;
  z-index: 1;
}
</style>
